import { toMoney, toPercent }  from 'bizcap-commons-web/dist/formatter';
import { ISimulationParams } from './Types';

export type Format = 'money' | 'moneyNoDigits' | 'percentage';

export const formatter = (format: Format, value: number) => (
	{
		money: (value: number) => `R$<span class="bold">${toMoney(value).replace('R$', '')}</div>`,
		moneyNoDigits: (value: number) => toMoney(value, { hideFractionDigits: true }),
		percentage: (value: number) => toPercent(value * 100),
	}[format](value)
);

export const addDays = (date: Date, days: number): Date => {
	const clonedDate = new Date(date.valueOf());

	clonedDate.setDate(clonedDate.getDate() + days);
	clonedDate.setHours(0, 0, 0, 0);

	return clonedDate;
}

export const getInitialSimulationParams = (): ISimulationParams => {
	const MIN_AMOUNT = 5000;
	const MIN_TENURE = 3;
	const MIN_INTEREST_RATE = 2.0;

	const loanDate = addDays(new Date(), 5);
	const dueDate = addDays(loanDate, 30);

	const amountInput = document.querySelector<HTMLInputElement>('form input[name=amount]');
	const tenureInput = document.querySelector<HTMLInputElement>('form input[name=tenure]');

	return {
		amount: Number(amountInput?.value) || MIN_AMOUNT,
		tenure: Number(tenureInput?.value) || MIN_TENURE,
		interestRate: MIN_INTEREST_RATE,
		loanDate,
		dueDate,
	}
}